<script setup lang="ts">
import { onMounted, watch } from 'vue'

import EmbedContentLoader from './EmbedContentLoader.vue'

declare global {
  interface Window {
    FB: {
      XFBML: {
        parse: () => void;
      };
      init: (config: { xfbml: boolean; autoLogAppEvents: boolean; version: string }) => void;
    };
    fbAsyncInit: () => void;
  }
}

const props = defineProps({
  html: {
    type: String,
    required: true
  }
})

const triggerEmbedScript = () => {
  if (typeof window !== 'undefined') {
    if (window.FB !== undefined) {
      window.FB.XFBML.parse()
    } else {
      window.fbAsyncInit = function () {
        window.FB.init({
          xfbml: true, // this option will look out for embeds and replace them for us
          autoLogAppEvents: false,
          version: 'v3.0'
        })
      };
      (function (d, s, id) {
        const fjs = d.getElementsByTagName(s)[0]
        if (d.getElementById(id)) { return }
        const js = d.createElement(s) as HTMLScriptElement; js.id = id
        js.src = 'https://connect.facebook.net/de_DE/sdk.js'
        if (fjs.parentNode) {
          fjs.parentNode.insertBefore(js, fjs)
        }
      }(document, 'script', 'facebook-jssdk'))
    }
  }
}

onMounted(() => {
  triggerEmbedScript()
})

watch(() => props.html, () => {
  triggerEmbedScript()
})
</script>

<template>
  <EmbedContentLoader class="min-h-[250px]"
                      :html="html"
                      @script-loaded="triggerEmbedScript()" />
</template>
